module.exports = __webpack_public_path__ + "img/eg-26-01.6c2d72cd.jpg";